import HttpClient from "./HttpClient";

export default class GlassUnit {
    constructor(glassUnit) {
        this.id = glassUnit.id;
        this.supplier_barcode = glassUnit.supplier_barcode;
        this.supplier_order = glassUnit.supplier_order;
        this.supplier_position = glassUnit.supplier_position;
        this.customer_barcode = glassUnit.barcode;
        this.customer_order = glassUnit.customer_order;
        this.customer_position = glassUnit.customer_position
        this.customer_marking = glassUnit.customer_marking;
        this.type = glassUnit.type;
        this.width = glassUnit.width;
        this.height = glassUnit.height;
        this.text = glassUnit.text;
        this.stand_number = glassUnit.stand_number;
        this.ordered_date = glassUnit.ordered_date;
        this.loaded_date = glassUnit.loaded_date;
        this.status = glassUnit.status;
        this.stand_side = glassUnit.stand_side;
        this.created_at = glassUnit.created_at;
        this.updated_at = glassUnit.updated_at;
    }

    static async getGlassUnits(filter, page, order, orderBy){
        const client = new HttpClient();
        const unitsResponse = await client.instance.get("glass-units", {
            params: {
                filter: filter,
                page: page,
                order: order,
                order_by: orderBy
            }
        });
        const units = [];
        unitsResponse.data.data.forEach(unit => {
            units.push(new GlassUnit(unit));
        });
        const pages = unitsResponse.data.last_page;
        const total = unitsResponse.data.total;
        return {units, pages, total};
    }

    static async upload(files) {
        const client = new HttpClient();
        for (const file of files) {
            try {
                let formData = new FormData();
                formData.append("glass-units", file);
                await client.instance.post("glass-units", formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
            } catch (error) {
                return 0;
            }
        }
        return 1;
    }
}